export default __webpack_public_path__ + "static/media/MotherDay_15.d86eac31.png";